import { render, staticRenderFns } from "./ListNntTagView.vue?vue&type=template&id=1ba900f2"
import script from "./ListNntTagView.vue?vue&type=script&lang=ts"
export * from "./ListNntTagView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports